import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountingService } from '@app/modules/my-business/services/accounting.service';

@Component({
  selector: 'sbnb-new-accounting-wizard',
  templateUrl: './new-accounting-wizard.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewAccountingWizardComponent implements OnInit {
  private readonly accountingService = inject(AccountingService);
  private readonly route = inject(ActivatedRoute);

  public ngOnInit() {
    this.accountingService.init(this.route.snapshot.queryParams.businessUuid, this.route.snapshot.params.id);
  }
}
